import get from "lodash/get";
import { format } from "date-fns";
import React, { useState } from "react";
import Slideshow from "../story-templates/story-elements/slide-show";
import { StoryElement } from "@quintype/components";
import HeroImage from "../story-templates/story-header/hero-image";
import CardImage from "../atoms/cardimage";
import { googleLogout } from "@react-oauth/google";

export const getHeadline = (story) => {
  if (!story) {
    return null;
  }

  return get(story, ["alternative", "home", "default", "headline"]) || story.headline;
};

export const getSectionName = (story) => {
  return get(story, ["sections", "0", "display-name"]) || get(story, ["sections", "0", "name"]);
};

export const getSectionName2 = (story, index = 1) => {
  const urlObj = new URL(story.url);
  const pathParts = urlObj.pathname.split("/");
  const sectionName = pathParts[pathParts.length - (index + 1)];
  return sectionName || null;
};

export const getSectionSlug = (story, index = 0) => get(story, ["sections", index, "slug"], "");
export const getSectionSlug2 = (config, story, index = 0) => {
  const urlObj = new URL(story.url);
  const pathParts = urlObj.pathname.split("/");
  const sectionName = pathParts[pathParts.length - (index + 1)];
  const sectionSlug = config.sections.find((section) => section.slug === sectionName);
  return sectionSlug ? sectionSlug?.collection?.slug : null;
};

export const getSectionCollectionSlug = (config, sectionName) => {
  const section = config.sections.find((section) => section.slug === sectionName);
  return section ? section?.collection?.slug : null;
};

export { handleTimeFormat, formatStoryDate } from "./date-utils";

export const storyPageBodyAd = (story, isImmersiveStory) => {
  const searchParams = new URLSearchParams(window.location.search);
  const utmSource = searchParams.get("utm_source");
  const ele = document.querySelector("#text-element-with-ad p");

  const allPtags = document.querySelectorAll(".story-cards p");
  const allStoryElements = document.querySelectorAll(".story-cards .story-element");

  if (
    ele &&
    story["story-template"] !== "dh-exclusive" &&
    story["story-template"] !== "exclusive-story-without-ad" &&
    story["story-template"] !== "immersive" &&
    (isImmersiveStory ? (allPtags.length > 1 ? true : false) : true)
  ) {
    const adText = document.createElement("div");
    adText.textContent = "ADVERTISEMENT";
    adText.id = "container-text";
    ele.appendChild(adText);

    const desktopAd = document.createElement("div");
    desktopAd.id = utmSource === "izooto" ? "div-gpt-ad-1711971649563-0" : "div-gpt-ad-1680156704803-0";
    desktopAd.className = "hide-mobile story-body-ad";

    const mobileAd = document.createElement("div");
    mobileAd.id = utmSource === "izooto" ? "div-gpt-ad-1711972030627-0" : "div-gpt-ad-1680157855094-0";
    mobileAd.className = "hide-desktop story-body-ad";
    ele.append(desktopAd);
    ele.append(mobileAd);
  }
};

export const updateUrl = (nextPage, pageNumber) => {
  const urlPath = window.location.pathname.replace(/\/$/, "");
  const urlParams = urlPath.split("/") || [];
  const pageNumPosition = pageNumber ? urlParams.length - 1 : urlParams.length;
  urlParams[pageNumPosition] = nextPage;
  const newPath = urlParams.join("/");
  const params = window.location.search;
  window.history.replaceState(null, null, `${window.location.origin}${newPath}${params}`);
};

export const getCurrentPageFromUrl = () => {
  if (typeof window === "undefined") return 1;
  const pathname = window.location.pathname.replace(/\/$/, "");
  const parts = pathname.split("/").filter(Boolean);
  const lastPart = parts[parts.length - 1];
  const pageFromUrl = parseInt(lastPart, 10);
  return !isNaN(pageFromUrl) && pageFromUrl > 0 ? pageFromUrl : 1;
};

export const updateListingPageUrl = (nextPage) => {
  if (typeof window === "undefined") return;
  const pathname = window.location.pathname.replace(/\/$/, "");
  const parts = pathname.split("/").filter(Boolean);
  const lastPart = parts[parts.length - 1];
  const hasPageSegment = parts.length > 0 && !isNaN(parseInt(lastPart, 10));
  const params = window.location.search || "";

  if (nextPage === 1) {
    if (hasPageSegment) {
      const baseParts = parts.slice(0, parts.length - 1);
      const newPath = `/${baseParts.join("/")}`.replace(/\/$/, "") || "/";
      window.history.replaceState(null, null, `${window.location.origin}${newPath}${params}`);
    }
    return;
  }

  if (hasPageSegment) {
    updateUrl(nextPage, nextPage);
  } else {
    updateUrl(nextPage, null);
  }
};

export const extractTextFromHtml = (htmlString) => {
  const re = /<[^>]*>/g;
  const text = htmlString.replace(re, "");
  return text.replace(/&nbsp;/g, " ") || "";
};

export function setAuthCookie(name, value, expiryDate) {
  if (typeof window === "undefined" || !name) return;
  const isProduction = process.env.NODE_ENV === "production";
  const secureStr = isProduction ? "; Secure" : "";
  const hostname = window.location.hostname || "";
  const domainStr = hostname.endsWith("deccanherald.com") ? "; Domain=.deccanherald.com" : "";

  let cookieString = `${name}=${encodeURIComponent(value)}; Path=/${domainStr}${secureStr}; SameSite=Lax`;
  if (expiryDate instanceof Date && !isNaN(expiryDate.getTime()) && expiryDate > new Date()) {
    cookieString += `; Expires=${expiryDate.toUTCString()}`;
  }
  document.cookie = cookieString;
}

export function getAuthCookie(name) {
  if (typeof window === "undefined") return null;
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) {
    return decodeURIComponent(match[2]);
  }
  return null;
}

export function removeAuthCookie(name) {
  if (typeof window === "undefined" || !name) return;
  const isProduction = process.env.NODE_ENV === "production";
  const secureStr = isProduction ? "; Secure" : "";

  // Delete with wildcard domain
  document.cookie = `${name}=; Path=/; Domain=.deccanherald.com; Expires=Thu, 01 Jan 1970 00:00:00 GMT${secureStr}; SameSite=Lax`;
  // Delete with current host domain
  document.cookie = `${name}=; Path=/; Domain=${window.location.hostname}; Expires=Thu, 01 Jan 1970 00:00:00 GMT${secureStr}; SameSite=Lax`;
  // Delete with dot-prefixed current host domain
  if (!window.location.hostname.startsWith('.')) {
    document.cookie = `${name}=; Path=/; Domain=.${window.location.hostname}; Expires=Thu, 01 Jan 1970 00:00:00 GMT${secureStr}; SameSite=Lax`;
  }
  // Delete without domain (defaults to current host)
  document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT${secureStr}; SameSite=Lax`;
}

export function clearAuthCookies() {
  removeAuthCookie("st-access-token");
  removeAuthCookie("st-refresh-token");
  removeAuthCookie("qt-auth");
}

export function performClientLogout(dispatch) {
  if (typeof window === "undefined") return;

  window.logoutInProgress = true;

  // 1. Clear Local Storage
  const localStorageKeys = ["access_token", "refresh_token", "user", "commentsToken", "last_logged_in_uuid"];
  localStorageKeys.forEach((key) => {
    try {
      window.localStorage.removeItem(key);
    } catch (e) {
      console.error(`Error clearing localStorage key ${key}:`, e);
    }
  });

  // 2. Clear Session Storage
  try {
    window.sessionStorage.removeItem("subscribe_payment_processing_state");
    window.sessionStorage.removeItem("show_support_strip_on_redirect");
  } catch (e) {
    console.error("Error clearing sessionStorage:", e);
  }

  // 3. Clear Cookies
  clearAuthCookies();

  // 4. Invalidate AccessType User State
  if (window.AccessType && typeof window.AccessType.setUser === "function") {
    try {
      window.AccessType.setUser({ emailAddress: null, mobileNumber: null, accesstypeJwt: null });
      console.log("[AUTH] AccessType user state cleared on logout.");
    } catch (e) {
      console.error("Failed to reset AccessType user state:", e);
    }
  }

  // 5. Reset Redux State
  const activeDispatch = dispatch || window.store?.dispatch;
  if (activeDispatch) {
    const { setIsLogin, setUserDetails, updateSubscriberStatus } = require("../store/actions");
    activeDispatch(setIsLogin(false));
    activeDispatch(setUserDetails(null));
    activeDispatch(updateSubscriberStatus(false));
    console.log("[AUTH] Redux auth and subscriber states reset on logout.");
  }
}

export function getJwtExpiry(token) {
  if (!token) return null;
  try {
    const parts = token.split('.');
    if (parts.length === 3) {
      let base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
      while (base64.length % 4) {
        base64 += '=';
      }
      const payload = JSON.parse(atob(base64));
      if (payload && typeof payload.exp === 'number') {
        return new Date(payload.exp * 1000);
      }
    }
  } catch (e) {
    // Silence noisy warning for non-JWT tokens (like refresh tokens)
  }
  return null;
}

export function getAccessToken() {
  return getAuthCookie("st-access-token") || (typeof window !== "undefined" && window.localStorage?.getItem("access_token")) || null;
}

export function getRefreshToken() {
  return getAuthCookie("st-refresh-token") || (typeof window !== "undefined" && window.localStorage?.getItem("refresh_token")) || null;
}

export function initializeAuthSync() {
  if (typeof window === "undefined") return false;
  const stAccessToken = getAuthCookie("st-access-token");
  const stRefreshToken = getAuthCookie("st-refresh-token");

  if (stRefreshToken) {
    console.log("[COOKIE SYNC] Refresh cookie detected. Ensuring Local Storage is in sync.");
    if (localStorage.getItem("refresh_token") !== stRefreshToken) {
      console.log("[COOKIE SYNC] Restoring missing/differing refresh_token in Local Storage");
      localStorage.setItem("refresh_token", stRefreshToken);
    }
    if (stAccessToken && localStorage.getItem("access_token") !== stAccessToken) {
      console.log("[COOKIE SYNC] Restoring missing/differing access_token in Local Storage");
      localStorage.setItem("access_token", stAccessToken);
    }
    return true;
  } else {
    // Cookies are missing, meaning user logged out or session expired. Clear Local Storage.
    if (localStorage.getItem("access_token") || localStorage.getItem("refresh_token")) {
      console.log("[COOKIE SYNC] Auth cookies are missing. Cleaning Local Storage to sync logout.");
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("user");
      localStorage.removeItem("commentsToken");
    }
    return false;
  }
}

export function addTokensToLocalStorage(access_token, refresh_token) {
  if (window) {
    const cleanAccessToken = access_token.replaceAll(" ", "+");
    const cleanRefreshToken = refresh_token.replaceAll(" ", "+");

    // 1. Write directly to the cookies first
    const accessExpiry = getJwtExpiry(cleanAccessToken);
    setAuthCookie("st-access-token", cleanAccessToken, accessExpiry);

    const refreshExpiry = getJwtExpiry(cleanRefreshToken);
    setAuthCookie("st-refresh-token", cleanRefreshToken, refreshExpiry);

    // Also write qt-auth cookie
    document.cookie = [`qt-auth=${encodeURIComponent(cleanAccessToken)}`, "Path=/", "Secure", "SameSite=Lax"].join("; ");

    // 2. Then populate Local Storage
    localStorage.setItem("access_token", cleanAccessToken);
    localStorage.setItem("refresh_token", cleanRefreshToken);
  }
}

export function getUserDetails() {
  const url = "/get-user-details";
  const timestamp = Date.now();
  // Adding a timestamp to the URL to ensure it's always unique and server treats it as new request.
  const newUrl = `${url}?timestamp=${timestamp}`;

  const access_token = getAccessToken();

  if (access_token?.length > 0) {
    return fetch(newUrl, { headers: new Headers({ Authorization: `Bearer ${access_token}` }) })
      .then(async (response) => {
        if (response?.status === 401) {
          return await refreshAccessToken(getUserDetails)
            .then((res) => {
              return res;
            })
            .catch((err) => {
              return err;
            });
        } else {
          return response.json();
        }
      })
      .then((userdata) => {
        return userdata;
      })
      .catch((err) => {
        return err;
      });
  } else {
    const refresh_token = getRefreshToken();
    if (refresh_token?.length > 0) {
      return refreshAccessToken(getUserDetails);
    }
  }
}

export function putUserDetails(data) {
  const url = "/put-user-details";

  const access_token = getAccessToken();

  if (access_token?.length > 0) {
    return fetch(url, {
      headers: new Headers({ Authorization: `Bearer ${access_token}`, "Content-Type": "application/json" }),
      method: "POST",
      body: JSON.stringify(data)
    })
      .then(async (response) => {
        if (response?.status === 401) {
          return await refreshAccessToken(() => putUserDetails(data))
            .then((res) => {
              return res;
            })
            .catch((err) => {
              return err;
            });
        } else {
          return response.json();
        }
      })
      .then((userdata) => {
        return userdata;
      })
      .catch((err) => {
        return err;
      });
  } else {
    const refresh_token = getRefreshToken();
    if (refresh_token?.length > 0) {
      return refreshAccessToken(() => putUserDetails(data));
    }
  }
}

let refreshTokenPromise = null;

export function refreshAccessToken(callbackFunction) {
  const url = "/refresh-token";

  const refresh_token = getRefreshToken();

  if (refresh_token?.length > 0) {
    if (!refreshTokenPromise) {
      console.log("[AUTH] Initiating new /refresh-token network request...");
      refreshTokenPromise = fetch(url, { method: "POST", headers: new Headers({ Authorization: `Bearer ${refresh_token}` }) })
        .then((response) => {
          if (!response.ok) {
            console.error(`[AUTH] /refresh-token failed with status ${response.status} ${response.statusText}`);
            throw new Error(JSON.stringify({ status: response.status, statusText: response.statusText }));
          } else {
            return response.json();
          }
        })
        .then((tokendata) => {
          console.log("[AUTH] Refresh request succeeded.");
          addTokensToLocalStorage(tokendata?.["st-access-token"], tokendata?.["st-refresh-token"]);
        })
        .finally(() => {
          console.log("[AUTH] Refresh token network request completed. Releasing lock.");
          refreshTokenPromise = null;
        });
    } else {
      console.log("[AUTH] Refresh already in progress. Waiting for existing promise...");
    }

    return refreshTokenPromise
      .then(() => {
        console.log("[AUTH] Existing request retried after successful refresh.");
        return callbackFunction();
      })
      .catch((err) => {
        console.error("[AUTH] Refresh token flow encountered an error:", err);
        console.log("[AUTH] Session termination initiated due to refresh failure.");

        if (typeof window !== "undefined") {
          if (window.logoutInProgress) {
            console.log("[AUTH] Manual logout in progress. Skipping duplicate termination redirect.");
            return;
          }
          try {
            performClientLogout();

            try { googleLogout(); } catch (e) { console.error("[AUTH] Google logout error:", e); }

            const ssoEndpoint =
              window.store?.getState?.()?.qt?.config?.["publisher-attributes"]?.sso_endpoint ||
              window.qtState?.config?.["publisher-attributes"]?.sso_endpoint ||
              "https://sso.deccanherald.com";

            const redirectUrl = window.location.href.split("?")[0];

            if (!window.location.pathname.includes("/auth/logout")) {
               window.location.href = `${ssoEndpoint}/auth/logout?redirectUrl=${encodeURIComponent(redirectUrl)}`;
            }
          } catch(e) {
            console.error("[AUTH] Error during session termination:", e);
          }
        }

        let catchError;
        try {
          // for error thrown if status code is not 200
          catchError = JSON.parse(err?.message);
        } catch (error) {
          catchError = err;
        }
        document.cookie = "qt-auth=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Secure; SameSite=Lax";
        throw catchError;
      });
  }
}

export function generateTokenForCommenting(userObject) {
  return fetch("/generate-comments-token", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(userObject)
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch((error) => {
      console.log(error);
    });
}

export function signInUpWithGoogleOneTap(id_token) {
  const signInBody = {
    thirdPartyId: "google",
    clientType: "web",
    oAuthTokens: {
      id_token
    }
  };

  return fetch("/sign-in-with-token", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      rid: "thirdpartypasswordless"
    },
    body: JSON.stringify(signInBody)
  })
    .then((response) => response.json())
    .then((tokendata) => {
      addTokensToLocalStorage(tokendata?.["st-access-token"], tokendata?.["st-refresh-token"]);
    })
    .catch((error) => {
      console.log(error);
    });
}
const HeroYoutubeOverride = ({ matchedElement, story }) => {
  const [loadIframe, setLoadIframe] = React.useState(false);

  const embedUrl = matchedElement["embed-url"] || "";
  const ytId = embedUrl
    ? embedUrl.split("/embed/")[1]?.split("?")[0]
    : null;

  return (
    <div
      onClick={() => setLoadIframe(true)}
      style={{
        position: "relative",
        cursor: "pointer",
      }}
      id="video-replacement-element"
    >
      {ytId && !loadIframe && (
        <div style={{ position: "relative" }} id="yt-herom-image-wrapper-nB">
          <img
            src={`https://img.youtube.com/vi/${ytId}/hqdefault.jpg`}
            alt=""
            loading="eager"
            style={{
              width: "100%",
              display: "block",
            }}
          />

          {/* Play button */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              pointerEvents: "none",
            }}
          >
            <svg
              viewBox="0 0 68 48"
              style={{
                width: "68px",
                height: "48px",
              }}
            >
              <path
                d="M66.52 7.74c-0.78-2.93-3.08-5.23-6.01-6.01
                   C55.14 0 34 0 34 0S12.86 0 7.49 1.73
                   c-2.93 0.78-5.23 3.08-6.01 6.01
                   C0 13.11 0 24 0 24s0 10.89 1.48 16.26
                   c0.78 2.93 3.08 5.23 6.01 6.01
                   C12.86 48 34 48 34 48s21.14 0 26.51-1.73
                   c2.93-0.78 5.23-3.08 6.01-6.01
                   C68 34.89 68 24 68 24s0-10.89-1.48-16.26z"
                fill="#f00"
              />
              <path d="M45 24L27 14v20" fill="#fff" />
            </svg>
          </div>
        </div>
      )}

      {loadIframe && (
        <StoryElement element={matchedElement} story={story} />
      )}
    </div>
  );
};


export const getHeroOverrideElement = ({
  story,
  heroImageOverride,
  showHeroImage = true,
  inStory = true,
  textColor = null,
}) => {
  if (!story?.id) {
    return { component: null, elementId: 0 };
  }

  let matchedElement = null;
  let matchedType = null;

  if (heroImageOverride) {
    for (const card of story.cards || []) {
      const overrideType =
        card?.metadata?.attributes?.cardheroimageoverride?.[0];

      if (!overrideType) continue;

      const elements = card?.["story-elements"] || [];

      if (overrideType === "slideshow") {
        const el = elements.find(
          (e) =>
            e?.type === "composite" &&
            e?.metadata?.type === "slideshow" &&
            e?.subtype === "image-gallery"
        );

        if (el) {
          matchedElement = el;
          matchedType = "slideshow";
          break;
        }
      }

      if (overrideType === "video") {
        const el = elements.find(
          (e) => e?.type === "youtube-video"
        );

        if (el) {
          matchedElement = el;
          matchedType = "video";
          break;
        }
      }
    }
  }

  if (!matchedElement) {
    if (showHeroImage) {
      return {
        component:
          story?.["story-template"] === "photo" && !inStory ? (
            <a href={`/${story.slug}`}>
              <CardImage
                story={story}
                showVideoIcon
                aspectRatio={[16, 9]}
                imageType={"image16x9"}
                widths={[400, 700]}
                sizes="(max-width: 1024px) 20vw, 100vw"
              />
            </a>
          ) : story?.["story-template"] === "video" && !inStory && !story?.["hero-image-s3-key"] ? (
            <a href={`/${story.slug}`}>
              <CardImage
                story={story}
                showVideoIcon
                aspectRatio={[16, 9]}
                imageType={"image16x9"}
                widths={[400, 700]}
                sizes="(max-width: 1024px) 20vw, 100vw"
              />
            </a>) :
            story["hero-image-s3-key"] ? (
              (inStory ? (
                <HeroImage story={story} newBlock={true} inStory={inStory} />
              ) : (
                <a href={`/${story.slug}`}>
                  <HeroImage story={story} newBlock={true} inStory={inStory} />
                </a>
              ))
            ) : !inStory ? (
              <a href={`/${story.slug}`}>
                <picture>
                  <img
                    style={{
                      maxHeight: "444px",
                      width: "100%",
                      aspectRatio: "1.55",
                      objectFit: "cover",
                      ...(inStory && { marginBottom: "36px" })
                    }}
                    src="https://images.assettype.com/deccanherald/2026-05-07/wylg8aw2/DHcover.svg"
                    alt="fallback"
                  />
                </picture>
              </a>
            ) : null,

        matchedType: "image",
        elementId: 0,
      };
    }
    return { component: null, elementId: 0, matchedType: null };
  }

  if (matchedType === "slideshow") {
    return {
      elementId: matchedElement.id,
      matchedType: "slideshow",
      component: (
        <Slideshow
          story={story}
          element={matchedElement}
          auto={true}
          NewBlock={true}
          inStory={inStory}
          textColor={textColor}
        />
      ),
    };
  }

  if (matchedType === "video") {
    return {
      elementId: matchedElement.id,
      matchedType: "video",
      component: (
        <HeroYoutubeOverride
          matchedElement={matchedElement}
          story={story}
        />
      ),
    };
  }

  return { component: null, elementId: 0, matchedType: null };
};

export function changeEmailOtp(email, redirectUrl = "") {
  const access_token = localStorage.getItem("access_token");
  if (!access_token) return Promise.reject("No token");

  return fetch("/change-email-otp", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access_token}`,
      redirecturl: redirectUrl
    },
    body: JSON.stringify({ email })
  }).then(async (response) => {
    if (response?.status === 401) {
      return await refreshAccessToken(() => changeEmailOtp(email, redirectUrl));
    }
    const data = await response.json();
    if (!response.ok) {
      const err = new Error(data?.errorMessage || data?.message || "Request failed");
      err.status = response.status;
      throw err;
    }
    return data;
  });
}

export function changePhoneOtp(phoneNumber, redirectUrl = "") {
  const access_token = localStorage.getItem("access_token");
  if (!access_token) return Promise.reject("No token");

  return fetch("/change-phone-otp", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access_token}`,
      redirecturl: redirectUrl
    },
    body: JSON.stringify({ phoneNumber })
  }).then(async (response) => {
    if (response?.status === 401) {
      return await refreshAccessToken(() => changePhoneOtp(phoneNumber, redirectUrl));
    }
    const data = await response.json();
    if (!response.ok) {
      const err = new Error(data?.errorMessage || data?.message || "Request failed");
      err.status = response.status;
      throw err;
    }
    return data;
  });
}

export function verifySsoCode(payload) {
  const access_token = localStorage.getItem("access_token");
  if (!access_token) return Promise.reject("No token");

  return fetch("/verify-sso-code", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access_token}`
    },
    body: JSON.stringify(payload)
  }).then(async (response) => {
    if (response?.status === 401) {
      return await refreshAccessToken(() => verifySsoCode(payload));
    }
    const data = await response.json();
    if (!response.ok) {
      const err = new Error(data?.errorMessage || data?.message || "Request failed");
      err.status = response.status;
      throw err;
    }
    return data;
  });
}
